import styled, { css } from 'styled-components';
import ReactSimpleDropdown, { DropdownContent } from 'react-simple-dropdown';
import { IconButton } from '@omilia/button';
import { colors } from '@omilia/theme';

import { getThemeProp } from 'theme';

export const SIcon = styled.i`
  display: inline-block;
`;

export const SDropdownTriggerContainer = styled.div`
  font-size: 0;
  padding: 0 4px;
  position: relative;

  ${SIcon} {
    border-radius: 5px;
    color: ${getThemeProp('colors.solitudeGrey')};
    display: inline-block;
    font-size: 20px;
    line-height: 20px;
    padding: 4px 5px 0;
    vertical-align: middle;

    &:hover {
      background-color: rgba(255, 255, 255, 0.1);
      color: ${getThemeProp('colors.moonRakerBlue')};
    }
  }
`;

export const SHeader = styled.div`
  align-items: center;
  box-shadow: inset 0 -1px 0 0 ${getThemeProp('colors.mercuryGrey5')};
  color: ${getThemeProp('colors.silverChaliceGrey3')};
  display: flex;
  height: 46px;
  justify-content: space-between;
  padding-left: 22px;
  padding-right: 22px;

  ${SIcon} {
    color: ${getThemeProp('colors.electricViolet')};
    font-size: 17px;
    margin-right: 7px;
    transform: translateY(3px);
  }
`;

export const SBody = styled.div`
  flex: 1;
  overflow-y: auto;
  position: relative;

  ${(props: { isEmpty: boolean }) =>
    props.isEmpty &&
    css`
      align-items: center;
      display: flex;
      justify-content: center;
      text-align: center;

      p {
        margin: 0;
      }
    `}
`;

export const STitle = styled.div`
  align-items: center;
  display: inline-flex;
`;

export const SName = styled.div`
  color: ${getThemeProp('colors.electricViolet')};
  font-size: 13px;
  font-weight: 500;
  letter-spacing: 0.1px;
  line-height: 16px;
  text-transform: uppercase;
`;

export const SDropdownContent = styled(DropdownContent)`
  &&& {
    border-radius: 0;
    bottom: 0;
    box-shadow: inset 1px 0 0 0 ${getThemeProp('colors.mercuryGrey5')},
      5px 20px 30px 0 rgba(0, 0, 0, 0.2);
    box-sizing: border-box;
    height: calc(100vh - 46px);
    padding: 0;
    position: fixed;
    right: 0;
    text-align: left;
    top: 44px;
    width: 300px;
    z-index: 9999;

    .dropdown--active & {
      display: flex;
      flex-direction: column;
    }
  }
`;

export const SIconClose = styled.i.attrs(() => ({
  className: 'icon-close',
}))`
  color: ${getThemeProp('colors.ghateauGrey')};
  display: inline-block;
  font-size: 10px;
  width: 10px;
  cursor: pointer;
`;

export const SUnreadCount = styled.span`
  background: ${getThemeProp('colors.electricViolet')};
  border-radius: 50%;
  color: ${getThemeProp('colors.white')};
  font-size: 11px;
  font-weight: 700;
  height: 14px;
  left: 20px;
  line-height: 14px;
  min-width: 14px;
  padding: 0 3px;
  position: absolute;
  text-align: center;
  top: -1px;
  width: auto;
  z-index: 1;
`;

export const SDropdown = styled(ReactSimpleDropdown)`
  margin-right: 4px;
`;

export const SIconRefresh = styled(IconButton)`
  color: ${colors.COLOR_MAGENTA_800};
  margin-left: 10px;
`;
